import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Environment } from '../../../environments/environment.model';
import { EnvironmentInjector } from '@next/core-lib/environment';

export abstract class ArableAdviceService {
  protected readonly http = inject(HttpClient);
  protected readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-advice-service';
}
